(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // --- פתיחת תת-תפריט בריחוף עכבר (דסקטופ בלבד) ---
  (function () {
  var hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  document.querySelectorAll('.header__inline-menu details').forEach(function (detailsEl) {
    var submenuEl = detailsEl.querySelector(':scope > .header__submenu');
    var closeTimer;
    var parentList = detailsEl.closest('ul');

    detailsEl.style.setProperty('position', 'relative', 'important');

    if (submenuEl) {
      submenuEl.style.setProperty('display', 'block', 'important');
      submenuEl.style.setProperty('position', 'absolute', 'important');
      submenuEl.style.setProperty('top', '100%', 'important');
      submenuEl.style.setProperty('inset-inline-start', '0', 'important');
      submenuEl.style.setProperty('inset-inline-end', 'auto', 'important');
      submenuEl.style.setProperty('width', '14rem', 'important');
      submenuEl.style.setProperty('max-width', 'none', 'important');
      submenuEl.style.setProperty('opacity', '0', 'important');
      submenuEl.style.setProperty('visibility', 'hidden', 'important');
      submenuEl.style.setProperty('pointer-events', 'none', 'important');
      submenuEl.style.setProperty('transition', 'opacity 150ms ease', 'important');
    }

    function closeSiblings() {
      if (!parentList) return;
      Array.prototype.forEach.call(parentList.children, function (li) {
        var sibling = li.querySelector(':scope > header-menu > details, :scope > details');
        if (sibling && sibling !== detailsEl) {
          sibling.removeAttribute('open');
          var siblingSubmenu = sibling.querySelector(':scope > .header__submenu');
          if (siblingSubmenu) {
            siblingSubmenu.style.setProperty('opacity', '0', 'important');
            siblingSubmenu.style.setProperty('visibility', 'hidden', 'important');
            siblingSubmenu.style.setProperty('pointer-events', 'none', 'important');
          }
        }
      });
    }

    detailsEl.addEventListener('mouseenter', function () {
      if (!hoverQuery.matches) return;
      clearTimeout(closeTimer);
      closeSiblings();
      detailsEl.setAttribute('open', '');
      if (submenuEl) {
        submenuEl.style.setProperty('opacity', '1', 'important');
        submenuEl.style.setProperty('visibility', 'visible', 'important');
        submenuEl.style.setProperty('pointer-events', 'auto', 'important');
      }
    });

    detailsEl.addEventListener('mouseleave', function () {
      if (!hoverQuery.matches) return;
      closeTimer = setTimeout(function () {
        detailsEl.removeAttribute('open');
        if (submenuEl) {
          submenuEl.style.setProperty('opacity', '0', 'important');
          submenuEl.style.setProperty('visibility', 'hidden', 'important');
          submenuEl.style.setProperty('pointer-events', 'none', 'important');
        }
      }, 150);
    });

    var summaryEl = detailsEl.querySelector(':scope > summary');
    if (summaryEl) {
      summaryEl.addEventListener('click', function (event) {
        if (hoverQuery.matches) event.preventDefault();
      });
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
